import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Utils.
import { formatAsCurrency } from '../../../utils/';

// Siblings.
import './styles.css';

//------------------------------------------------------------------------------

const Result = ({ className, label, output, suffix, format }) =>
  <div className={classNames('Result', className)}>
    <span className="Result__Label">{label}</span>{' '}
    <span className="Result__Control">
      <span className="Result__Output">
        {!!format && typeof output === 'number'
          ? formatAsCurrency(output)
          : output}
      </span>{' '}
      {!!suffix &&
        <span className="Result__Suffix">
          {suffix}
        </span>}
    </span>
  </div>;

Result.propTypes = {
  className: PropTypes.string,
  label: PropTypes.node.isRequired,
  output: PropTypes.node.isRequired,
  suffix: PropTypes.node,
  format: PropTypes.bool,
};

Result.defaultProps = {
  className: null,
  suffix: null,
  format: false,
};

export default Result;



// WEBPACK FOOTER //
// ./src/components/Results/Result/index.js